import { render } from "./observer-scorecard.vue?vue&type=template&id=e19ff690&ts=true"
import script from "./observer-scorecard.vue?vue&type=script&lang=ts"
export * from "./observer-scorecard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__